import { Suspense, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import PageLoader from '../template/PageLoader';
import { Navbar } from '../template/Navbar';
import Sidebar, { SidebarItem } from '../template/Sidebar';
import { LayoutGrid, AlertCircle, MapPin, Settings, LogOut } from 'lucide-react';
import { Footer } from '../template/Footer';
import { PATHS } from '@/constants/page-paths';
import { useAuth } from '@/lib/hooks/useAuth';

const UserLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, logout, loading } = useAuth();

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      navigate(PATHS.LOGIN);
    }
  }, [isAuthenticated, loading, navigate]);

  const handleLogout = () => {
    logout();
    navigate(PATHS.LOGIN);
  };

  if (loading) {
    return <PageLoader />;
  }

  return (
    <div className='flex'>
      <Sidebar>
        <SidebarItem 
          icon={<LayoutGrid size={20} />} 
          text="Dashboard" 
          active={location.pathname === PATHS.DASHBOARD}
          onClick={() => navigate(PATHS.DASHBOARD)}
        />
        <SidebarItem 
          icon={<AlertCircle size={20} />} 
          text="Complaints" 
          active={location.pathname === PATHS.COMPLAINTS}
          onClick={() => navigate(PATHS.COMPLAINTS)}
        />
        <SidebarItem 
          icon={<MapPin size={20} />} 
          text="Technician Map" 
          active={location.pathname === PATHS.NEAREST_LOCATION}
          onClick={() => navigate(PATHS.NEAREST_LOCATION)}
        />
        <SidebarItem 
          icon={<Settings size={20} />} 
          text="Settings" 
          active={location.pathname === '/settings'}
          onClick={() => navigate('/settings')}
        />
        <div className="mt-auto">
          <SidebarItem 
            icon={<LogOut size={20} />} 
            text="Logout" 
            onClick={handleLogout}
          />
        </div>
      </Sidebar>
      <div className="flex flex-col flex-auto min-h-screen min-w-0 relative w-full">
        <Navbar />
        <div className={'h-full flex flex-auto flex-col justify-between mb-4'}>
          <Suspense fallback={<PageLoader />}>
            <main className="relative h-full flex flex-auto flex-col p-2 sm:px-6 md:px-8 sm:py-6 container">
              <Outlet />
            </main>
          </Suspense>
        </div>
        <Footer/>
      </div>
    </div>
  );
};

export default UserLayout;

